export default __webpack_public_path__ + "static/media/A0000.c11f0b28.png";